import { gql } from '@apollo/client';

export const ADD_INSTITUTION_TO_COHORTS = gql`
  mutation addInstitutionToCohorts($input: AddInstitutionToCohortsInput!) {
    institution: addInstitutionToCohorts(input: $input) {
      id
    }
  }
`;
